import Router from 'next/router'
import getConfig from 'next/config'

export const { publicRuntimeConfig: { basePath: BASE_PATH } } = getConfig()

export const PAGE_URL = {
  SCHEDULING: '/agendamentos',
  SCHEDULING_INDEX: '/agendamentos/bem-vindo',
  SCHEDULING_REVIEW: '/agendamentos/revisao-do-agendamento',
  SCHEDULING_SUMMARY: '/agendamentos/resumo-do-agendamento',
  HOW_TO_PAY: '/agendamentos/como-pagar',
  RESCHEDULE: '/agendamentos/alteracao',
  USER_PROFILE: '/meus-dados',
  PERMISSIONS: '/permissoes',
  USER_PETS: '/agendamentos/meus-pets',
  USER_CREDIT_CARDS: '/meus-cartoes',
  PET_PROFILE: '/agendamentos/perfil-pet',
  SERVICE_RULES: '/regras-de-servicos',
  SERVICE_TERMS: '/politica-de-uso',
  PACKAGE_ADHESION_TERMS: '/termo-adesao-pacote-banhos',
  PAGE_NOT_FOUND: '/pagina-nao-encontrada',
  HOW_IT_WORKS: '/como-funciona',
  CHECKOUT_ADDRESS: '/agendamentos/checkout/endereco',
  CHECKOUT_CARD: '/agendamentos/checkout/forma-de-pagamento',
  CHECKOUT_PAYMENT_REVIEW: '/agendamentos/checkout/revisao-do-pagamento',
  PACKAGE_SUCCESS: '/pacotes/sucesso',
  SATISFACTION_SURVEY: '/agendamentos/pesquisa-satisfacao',
  SATISFACTION_SURVEY_DETAIL: '/agendamentos/avaliacao',
  SCHEDULING_PET_AND_SERVICES: '/agendamentos/pet-e-servico',
  SCHEDULING_LOCATION: '/agendamentos/loja',
  SCHEDULING_PROFESSIONAL: '/agendamentos/profissional',
  SCHEDULING_DATE: '/agendamentos/data',
  SCHEDULING_FLOW_SELECTION: '/agendamentos/selecao-de-fluxo',
  SCHEDULING_DIARY: '/servicos/agendamentos/bem-vindo/?tab=agenda',
  SCHEDULING_DIARY_INTERNAL: '/agendamentos/bem-vindo/?tab=agenda',
  HIRED_SERVICES: '/gestao-de-servicos',
  HIRED_SERVICES_DETAILS: '/gestao-de-servicos/detalhes',
  BASE_URL: BASE_PATH
}

export const redirectToHome = (redirectTo, res) => {
  if (typeof window === 'undefined') {
    res.writeHead(302, {
      Location: `${BASE_PATH}${PAGE_URL.SCHEDULING_INDEX}`
    })
    res.end()
  } else {
    Router.push(PAGE_URL.SCHEDULING_INDEX)
  }
}

export const cleanCacheAndRedirect = async (redirectTo) => {
  window.localStorage.removeItem('schedulingState')
  window.localStorage.removeItem('paymentState')
  const category = window.localStorage.getItem('category') || 'BANHO_TOSA'
  const route = redirectTo ? PAGE_URL[redirectTo] : `${PAGE_URL.SCHEDULING_PET_AND_SERVICES}/?category=${category}`

  Router.push(route)
}
